const Wrap = ({ when, with: wrapper, children }) =>
  when ? wrapper(children) : children;

export default Wrap;
